/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_First_YearInputs */

const en_reference_field_first_year = /** @type {(inputs: Reference_Field_First_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First year`)
};

/**
* | output |
* | --- |
* | "First year" |
*
* @param {Reference_Field_First_YearInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_first_year = /** @type {((inputs?: Reference_Field_First_YearInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_First_YearInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_first_year(inputs)
});